<template>
  <div class="financeProgramStatusUpdater">
    <div class="financeProgramStatusUpdater__content">
      <div v-if="programs.length === 0">
        <span data-cy="noProgramsSelectedMessage">{{ noSelectionText }}</span>
      </div>
      <div v-else class="d-flex align-items-center">
        <div v-if="inactivePrograms.length">
          <Button data-cy="activate" primary @click="$emit('activate')"
            >Activate</Button
          >
        </div>
        <div v-if="activePrograms.length">
          <Button
            data-cy="deactivate"
            primary
            outline
            @click="$emit('deactivate')"
            >Deactivate</Button
          >
        </div>
        <div data-cy="programsSelected">
          {{ programs.length }} Program(s) selected
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import Button from "@/components/Button.vue";
import { LoanProgramDTResponse } from "../types";

const props = defineProps({
  programs: {
    type: Array as () => LoanProgramDTResponse[],
    default: () => []
  },
  statusFilter: {
    type: String,
    default: ""
  }
});

const activePrograms = computed(() => {
  return props.programs.filter((program) => program.status === "Active");
});

const inactivePrograms = computed(() => {
  return props.programs.filter((program) => program.status === "Inactive");
});

const noSelectionText = computed(() => {
  if (props.statusFilter === "active") {
    return "Select Financing Program(s) to Deactivate";
  } else if (props.statusFilter === "inactive") {
    return "Select Financing Program(s) to Activate";
  } else {
    return "Select Financing Program(s) to Activate or Deactivate";
  }
});
</script>

<style lang="scss" scoped>
.financeProgramStatusUpdater {
  background: var(--light-gray);
  padding: 16px;
  color: var(--font-color);
  font-weight: 600;
  bottom: 0;
}
:deep(.btn) {
  margin-right: 30px;
}
</style>
